import { render, staticRenderFns } from "./ChargingPointDetailIssueAdd.vue?vue&type=template&id=5752abd6"
import script from "./ChargingPointDetailIssueAdd.vue?vue&type=script&lang=js"
export * from "./ChargingPointDetailIssueAdd.vue?vue&type=script&lang=js"
import style0 from "./ChargingPointDetailIssueAdd.vue?vue&type=style&index=0&id=5752abd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports